module.exports = __webpack_public_path__ + "static/media/rewards-info.c6585c34.svg";